module.exports = __webpack_public_path__ + "static/media/8.9714c6d2.svg";